import { ReactNode, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Credentials } from '../../types';
import { defaultData, LoginState, LoginStateContext, LoginStateContextType } from './LoginStateContext';

type LoginStateProviderProps = {
  children: ReactNode;
};

export const LoginStateProvider = ({ children }: LoginStateProviderProps) => {
  const [loginState, setLoginState] = useState<LoginState>(LoginState.passwordless);
  const loginFormMethods = useForm<Credentials>({
    defaultValues: defaultData,
  });

  const switchToPasswordlessLogin = () => {
    setLoginState(LoginState.passwordless);
  };

  const switchToPasswordlessSuccess = () => {
    loginFormMethods.resetField('password');
    setLoginState(LoginState.passwordlessSuccess);
  };

  const switchToPasswordLogin = () => {
    setLoginState(LoginState.password);
  };

  const contextValue: LoginStateContextType = {
    loginState,
    loginFormMethods,
    switchToPasswordlessLogin,
    switchToPasswordlessSuccess,
    switchToPasswordLogin,
  };

  return <LoginStateContext.Provider value={contextValue}>{children}</LoginStateContext.Provider>;
};
